import { render, staticRenderFns } from "./direct_stock_transfer.vue?vue&type=template&id=0b7b91e0&"
import script from "./direct_stock_transfer.vue?vue&type=script&lang=js&"
export * from "./direct_stock_transfer.vue?vue&type=script&lang=js&"
import style0 from "./direct_stock_transfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports